import { ReloadOutlined } from "@ant-design/icons";
import type { SessionView } from "@p0security/shared/integrations/sessions/types";
import { Alert, Button, Flex, Typography } from "antd";

/** Shared header for normalized session evidence views. */
export const SessionViewHeader = ({
  view,
  fallbackTitle,
  loading,
  onRefresh,
}: {
  view: Pick<SessionView, "title" | "warnings">;
  fallbackTitle: string;
  loading?: boolean;
  onRefresh?: () => void;
}) => {
  return (
    <>
      <Flex align="center" justify="space-between" style={{ marginBottom: 16 }}>
        <Typography.Title level={5} style={{ margin: 0 }}>
          {view.title ?? fallbackTitle}
        </Typography.Title>
        {onRefresh && (
          <Button
            icon={<ReloadOutlined />}
            loading={loading}
            onClick={onRefresh}
          >
            Refresh
          </Button>
        )}
      </Flex>
      {view.warnings && view.warnings.length > 0 && (
        <Alert
          message="Partial session evidence"
          description={view.warnings.join(" ")}
          type="warning"
          showIcon
          style={{ marginBottom: "16px" }}
        />
      )}
    </>
  );
};
